import { createSelector } from 'reselect';
import { COMPLETED, PENDING, FAILED } from './actions';

export const getModelsLoaded = (state) => state.models.siteLoaded;

export const getAllModels = (state) => state.models.hashmap;

export const getModelVersions = (state, modelId) =>
  (state.models.hashmap[modelId] && state.models.hashmap[modelId].versions) || [];

export const checkHasModels = (state) => Object.keys(state.models.hashmap).length;

export const getModelIdsWithProcessingVersions = createSelector(getAllModels, (modelsMap) =>
  Object.values(modelsMap)
    .filter((model) => model.versions.some((v) => ![COMPLETED, PENDING, FAILED].includes(v.status)))
    .map((model) => model.id)
);

export const getUploadingIds = (state) => state.models.uploadingIds;
